(function () {
  'use strict';

  function mount(root) {
    if (!root || root.getAttribute('data-ec-footer-mounted') === 'true') return;
    root.setAttribute('data-ec-footer-mounted', 'true');

    var offer = root.querySelector('[data-ec-footer-open-offer]');
    var backToTop = root.querySelector('[data-ec-footer-top]');

    if (offer) {
      offer.addEventListener('click', function (event) {
        if (!document.querySelector('[data-ec-home-offer]')) return;
        event.preventDefault();
        document.dispatchEvent(new CustomEvent('ec:open-home-offer', {
          detail: { source: 'footer' }
        }));
      });
    }

    if (backToTop) {
      backToTop.addEventListener('click', function () {
        window.scrollTo({
          top: 0,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          document.documentElement.classList.toggle('ec-footer-in-view', entry.isIntersecting);
        });
      }, { threshold: 0.02 });
      observer.observe(root);
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ec-footer]').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
